import React, { useState, useEffect } from "react";
// componentes
import CardItem from "../../../components/CardItem";
// constantes
import { VIEW } from "../constants";

export default function ItemRoomOption(props) {
  const { setStep, name, setRoomSelected, saved, config } = props;
  // regra 1 por sala
  const [blockRoom, setBlockRoom] = useState(false);

  useEffect(() => {
    // regra de 1 por sala
    if (config.regra === "onePerRoom") {
      var search = saved.find((e) => e.sala === name);

      if (search) setBlockRoom(true);
    }
  }, []);

  return (
    <CardItem
      title={`${name} - Ver horários`}
      trailingIcon="bx bxs-right-arrow-circle"
      disabled={blockRoom}
      onClick={() => {
        setRoomSelected(name);
        setStep(VIEW.ROOM_TIMES);
      }}
    />
  );
}
